import { DirectiveOptions } from 'vue';
import { dataLayer } from '../globals';

let callback: any = null;
const onClick = (event: string, action: string, category: string, label?: string) => (e: Event): void => {
    dataLayer.push({
        eventAction: action,
        eventLabel: label,
        eventCategory: category,
        event,
    });
};

const gaClick: DirectiveOptions = {
    bind: (el, {value: {event, action, category, label}}): void => {
        callback = onClick(event, action, category, label);
        el.addEventListener('click', callback);

    },
    unbind: (el): void => {
        el.removeEventListener('click', callback);
    },
};

export default gaClick;



// WEBPACK FOOTER //
// ./src/directives/gaClick.ts